// ** IMPORTANT **: Keep in sync with functions/src/index.ts UNSUBSCRIBE_BY_MAIL_TRACKING_LINK_ERROR_CODE
export enum UNSUBSCRIBE_BY_MAIL_TRACKING_LINK_ERROR_CODE {
    invalidArgument = 'invalid-argument',
    notFound = 'not-found',
    failedPrecondition = 'failed-precondition',
    unknown = 'unknown',
}
